<template>
  <ConfirmModal
    v-if="showConfirmationModal"
    wrapper-class="max-w-4xl"
    :title="t('Reviews.reviewReply.delete.confirmModal.title')"
    :description="t('Reviews.reviewReply.delete.confirmModal.description')"
    @close-dialog="emit('canceled')"
  >
    <template #actions>
      <div class="mt-6 flex justify-end px-6 pb-6">
        <button class="btn-secondary-color-s ml-4" data-testid="accept-button" @click="emit('canceled')">
          {{ t('Reviews.reviewReply.delete.confirmModal.abort') }}
        </button>
        <button class="btn-primary-color-s ml-4" data-testid="reviews-reply-del-confirm" @click="emit('confirmed')">
          {{ t('Reviews.reviewReply.delete.confirmModal.confirm') }}
        </button>
      </div>
    </template>
  </ConfirmModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { ConfirmModal } from '@/components'

defineProps<{
  showConfirmationModal: boolean
}>()

const emit = defineEmits(['canceled', 'confirmed'])

const { t } = useI18n()
</script>
